import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";
import folder from "../../assets/Folder-icon.svg"

export function Portfolio(){
  return(
    <Container id="portfolio">
      <h2>Proyectos</h2>

      <div className="projects">

      <ScrollAnimation animateIn="flipInX">
        <div className="project">
          <header>
          <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#669bbc" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
          <div className="project-links">
            <a href="https://github.com/ArrascaetaFedericoIgnacio/PF-Henry" target="_blank" rel="noreferrer">
              <img src={githubIcon} alt="GitHub" />
            </a>
          </div>
          </header>
          <div className="body">
            <h3>E-commerce Smartnest</h3>
            <p>Este e-commerce ofrece una amplia selección de productos para el hogar con una sección de foro para su comunidad. Desarrollado con tecnologías modernas para brindar una experiencia de usuario óptima.
            </p>
          </div>
          <footer>
            <ul className="tech-list">
              {/* <li>Node</li> */}
              <li>Express</li>
              <li>MongoDB</li>
              <li>React</li>
              <li>TypeScript</li>
            </ul>
          </footer>
        </div>
      </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#669bbc" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            
              <a href="https://github.com/ArrascaetaFedericoIgnacio/PI-POKEMONS" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Pokemons SPA </h3>
              <p>Esta aplicación web permite buscar y visualizar información de los pokemons. Desarrollado con tecnologías modernas para brindar una experiencia de usuario óptima.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Node</li>
                <li>MySql</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#669bbc " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="https://github.com/ArrascaetaFedericoIgnacio/calendar-front" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Calendar App</h3>
              <p>Aplicación web que permite crear eventos y guardarlos en el calendario. 
                {/* detallame mas */}

              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>MongoDB</li>
                <li>Express</li>
                
                
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

     



      </div>
    </Container>
  );
}